// Animate only the nodes that consume each value. The corresponding registered
// properties do not inherit, so an SVG/card's descendants need no style update.
const targets = {
  "--phase":
    ".venue-space svg,.venue-selection,.sales-links path,.sales-links circle,.promoter,.sales-panel,.sales-row i,.scene-watermark span,.theatre-light,.theatre-floor,.access-window,.sales-chart i",
  "--foil-shift": ".journey-pass",
  "--qr-focus": ".journey-pass-bottom > div:first-child,.journey-qr",
  "--scan": ".scanner-line",
  "--scan-opacity": ".scanner-line",
  "--valid": ".access-result",
  "--benefit-phase":
    ".benefit-light,.benefit-phone,.checkout-trail path,.checkout-trail > span,.sales-origin,.money-building,.bank-columns,.bank-roof,.bank-destination,.payout-today i,.brand-experience,.depth-back,.depth-middle,.brand-cover,.brand-annotation",
  "--purchase-done":
    ".phone-checkout,.phone-success,.success-seal path,.purchase-arrival",
};

export function createMotionVars(root, activeScene) {
  const groups = Object.fromEntries(
    Object.entries(targets).map(([name, selector]) => [
      name,
      [...root.querySelectorAll(selector)].map((node) => {
        const panel = node.closest("[data-layer],[data-benefit-panel]");
        return {
          node,
          scene: panel
            ? Number(panel.dataset.layer ?? panel.dataset.benefitPanel)
            : null,
        };
      }),
    ])
  );
  const previous = new Map();
  return (name, value) => {
    const active = activeScene(),
      key = `${active}|${value}`;
    if (previous.get(name) === key) return;
    previous.set(name, key);
    for (const { node, scene } of groups[name] || []) {
      if (scene === null || scene === active)
        node.style.setProperty(`--fomo-launch-${name.slice(2)}`, value);
    }
  };
}
